<template>
	<div>
		<div class="row mb-3">
			<!-- desktop -->
			<div
				class="d-none d-sm-flex col-sm-4 body-strong text-grey-900 text-start"
			>
				{{ resumeAccommodation_text }}
			</div>
			<!-- mobile -->
			<div class="d-sm-none col-12 body-strong text-grey-900 text-start mb-2">
				{{ resumeAccommodation_text }}
			</div>

			<div class="col-12 col-sm-8 d-flex flex-column nowrap p-md-0">
				<div
					v-for="(prestObj, prestObj_i) in selectedPrestations"
					:key="prestObj_i"
					class="body-strong text-grey-900 d-flex justify-content-end mb-3 mb-md-1"
				>
					<span class="text-start col-6 mb-2">{{
						prestObj.prestation.prestName
					}}</span>
					<div class="col-4 d-flex justify-content-end">
						<AddRemove
							:minVal="1"
							:maxVal="prestObj.prestation.quantity"
							:num="prestObj.quantity"
							@plus="() => handlePlusClick(prestObj)"
							@minus="() => handleMinusClick(prestObj)"
						/>
					</div>
					<div class="col-2 d-flex justify-content-end align-items-center">
						<div class="me-2">
							<button
								@click="() => handleRemoveClick(prestObj)"
								class="ts-x-black ts-x-sm"
							></button>
						</div>
						<!-- <ClsBtn
							@click="() => handleRemoveClick(prestObj)"
							:classes="'position-absolute'"
						/> -->
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="">
        <ErrorMessage
            :position="'relative'"
            :zIndex="'1'"
            :classes="'w-100'"
            :maxWidth="'none'"
            :transition="'none'"
            :bottom="'none'"
            :right="'none'"
            :text="errorText"
            :margin="'none'"
            :fadeTimeOut="0"
            @close="handleErrorClose"
        />
    </div> -->
	</div>
</template>

<script>
import AddRemove from "@/vue/planning/components/common/addRemove.vue";
import { mapState, mapGetters } from "vuex";
import colors from "@/config/colors";
// import ErrorMessage from "@/vue/planning/components/common/errorMessage.vue"
import store from "@/vue/planning/store/store";

export default {
	store,
	name: "Accommodations",
	data() {
		return {
			colors,
			// errorText: ""
		};
	},
	components: {
		AddRemove,
		// ErrorMessage,
	},
	computed: {
		...mapState(["selectedPrestIds", "content", "errorMessageOpen"]),
		...mapGetters(["prestations", "selectedPrestations"]),
		resumeAccommodation_text() {
			if (Object.keys(this.selectedPrestIds).length === 1) {
				if (Object.values(this.selectedPrestIds)[0] > 1) {
					return this.content.planner_resumeAccommodations;
				} else {
					return this.content.planner_resumeAccommodation;
				}
			} else if (Object.keys(this.selectedPrestIds).length > 1) {
				return this.content.planner_resumeAccommodations;
			} else {
				return this.content.planner_resumeAccommodation;
			}
		},
	},

	methods: {
		handlePlusClick(prestObj) {
			const obj = {};
			obj[prestObj.prestation.id] = prestObj.quantity + 1;
			this.$store.dispatch("setSelectedPrestIds", obj);
		},
		handleMinusClick(prestObj) {
			const obj = {};
			obj[prestObj.prestation.id] = prestObj.quantity - 1;
			this.$store.dispatch("setSelectedPrestIds", obj);
		},
		handleRemoveClick(prestObj) {
			const obj = {};
			obj[prestObj.prestation.id] = 0;
			this.$store.dispatch("setSelectedPrestIds", obj);
		},
		// handleErrorClose() {
		//     this.$store.commit("setErrorMessageOpen", '')
		// },
	},

	// watch: {
	//     'errorMessageOpen': function(newVal, oldVal) {
	//         if (newVal === "errorMessages_morePrestationsSelectedThanAdults") {
	//             this.$set(this, "errorText", content[newVal])
	//         } else {
	//             this.$set(this, "errorText", "")
	//         }
	//     }
	// }
};
</script>

<style scoped>
.x-btn {
	transition: box-shadow 100ms ease-in-out;
	border: none;
	outline: none;
	width: 24px;
	height: 24px;
	user-select: none;
	-moz-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
}
.x-btn:hover {
	box-shadow: 0px 0px 4px 0px gray !important;
}
</style>
